import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/agency/locale';
Vue.use(Router)

import Login from "../view/Login"
import Home from '../view/Home'
import Default from '../view/Default'
import SortFile from '@/view/SortFile'
import HelpCenter from '@/view/HelpCenter'
import HelpCenterDetail from '@/view/HelpCenterDetail'
import BulletinCenter from '@/agency/view/BulletinCenter'
import BulletinCenterDetail from '@/view/BulletinCenterDetail'
import OperationMenu from '@/view/OperationMenu'
import SalSalesOrder from '@/agency/view/SalSalesOrder'
import SalSalesOrderDetail from '@/agency/view/SalSalesOrderDetail'
import SalDispatchList from '@/agency/view/SalDispatchList'
import SalDispatchListDetail from '@/agency/view/SalDispatchListDetail'
import OrderImport from '@/agency/view/OrderImport'
import OrderImportSer from '@/agency/view/OrderImportSer'
import ItemCodeQuery from '@/agency/view/ItemCodeQuery'
import ProductPicture from '@/agency/view/ProductPicture'
import UrgentApply from '@/agency/view/UrgentApply'
import ShipmentApply from '@/agency/view/ShipmentApply'
import PubPriceQuery from '@/agency/view/PubPriceQuery'
import UrgentQuery from '@/agency/view/UrgentQuery'
import ShipmentQuery from '@/agency/view/ShipmentQuery'
import OrderArrival from '@/agency/view/OrderArrival'
import OrderArrivalDetail from '@/agency/view/OrderArrivalDetail'
import APSearch from '@/agency/view/APSearch'
import StockRemainQuery from '@/agency/view/StockRemainQuery'
var routes = [
  {
    path: '/',
    redirect: '/Login'
  },
  {
    path: '/Login',
    component: Login,
    meta: {
      title: i18n.t('comm.login')
    }
  },
  {
    path: '/Home',
    component: Home,
    redirect: '/Home/Default',
    meta: {
      title: i18n.t('comm.default')
    },
    children: [
      {
        name:'Default',
        path: '/Home/Default',
        component: Default,
        meta: {
          title: i18n.t('comm.default')
        }
      },
      {
        name:"SalSalesOrder",
        path: '/Home/SalSalesOrder',
        component: SalSalesOrder,
        meta: {
          title: i18n.t('salSalesOrder.orderSearch')
        }
      }, 
      {
        name:"SalSalesOrderDetail",
        path: '/Home/SalSalesOrderDetail',
        component: SalSalesOrderDetail,
        meta: {
          title: i18n.t('salSalesOrderDetail.orderDetail')
        }
      }, 
      {
        name:"SalDispatchList",
        path: '/Home/SalDispatchList',
        component: SalDispatchList,
        meta: {
          title: i18n.t('salDispatchList.orderSearch')
        }
      }, 
      {
        name:"SalDispatchListDetail",
        path: '/Home/SalDispatchListDetail',
        component: SalDispatchListDetail,
        meta: {
          title: i18n.t('salDispatchListDetail.orderDetail')
        }
      },  
      {
        name:"SortFile",
        path: '/Home/SortFile',
        component: SortFile,
        meta: {
          title: i18n.t('comm.sortfile')
        }
      }, 
      {
        name:"HelpCenter",
        path: '/Home/HelpCenter',
        component: HelpCenter,
        meta: {
          title: i18n.t('comm.help')
        }
      }, 
      {
        name:"HelpCenterDetail",
        path: '/Home/HelpCenterDetail',
        component: HelpCenterDetail,
        meta: {
          title: i18n.t('comm.helpdetail')
        }
      },
      {
        name:"BulletinCenter",
        path: '/Home/BulletinCenter',
        component: BulletinCenter,
        meta: {
          title: i18n.t('comm.bulletin')
        }
      },{
        name:"BulletinCenterDetail",
        path: '/Home/BulletinCenterDetail',
        component: BulletinCenterDetail,
        meta: {
          title: i18n.t('comm.bulletindetail')
        }
      },
      {
        name:"OperationMenu",
        path:'/Home/OperationMenu-*',
        component:OperationMenu
      }, 
      {
        name:"OrderImport",
        path: '/Home/OrderImport',
        component: OrderImport,
        meta: {
          title: i18n.t('comm.orderImport')
        }
      }, 
      {
        name:"OrderImportSer",
        path: '/Home/OrderImportSer',
        component: OrderImportSer,
        meta: {
          title: i18n.t('comm.orderImportSer')
        }
      }, 
      {
        name:"UrgentApply",
        path: '/Home/UrgentApply',
        component: UrgentApply,
        meta: {
          title: i18n.t('salSalesOrder.urgentApplay')
        }
      }, 
      {
        name:"ShipmentApply",
        path: '/Home/ShipmentApply',
        component: ShipmentApply,
        meta: {
          title: i18n.t('salSalesOrder.shipmentApply')
        }
      }, 
      {
        name:"UrgentQuery",
        path: '/Home/UrgentQuery',
        component: UrgentQuery,
        meta: {
          title: i18n.t('UrgentQuery.title')
        }
      }, 
      {
        name:"ShipmentQuery",
        path: '/Home/ShipmentQuery',
        component: ShipmentQuery,
        meta: {
          title: i18n.t('ShipmentQuery.title')
        }
      }, 
      {
        name:"ItemCodeQuery",
        path: '/Home/ItemCodeQuery',
        component: ItemCodeQuery,
        meta: {
          title: i18n.t('comm.itemCodeQuery')
        }
      }, 
      {
        name:"ProductPicture",
        path: '/Home/ProductPicture',
        component: ProductPicture,
        meta: {
          title: i18n.t('comm.productPicture')
        }
      }, 
      {
        name:"PubPriceQuery",
        path: '/Home/PubPriceQuery',
        component: PubPriceQuery,
        meta: {
          title: i18n.t('comm.pubPriceQuery')
        }
      }, 
      {
        name:"OrderArrival",
        path: '/Home/OrderArrival',
        component: OrderArrival,
        meta: {
          title: i18n.t('comm.orderArrival')
        }
      }, 
      {
        name:"OrderArrivalDetail",
        path: '/Home/OrderArrivalDetail',
        component: OrderArrivalDetail,
        meta: {
          title: i18n.t('OrderArrivalDetail.orderDetail')
        }
      }, 
      {
        name:"APSearch",
        path: '/Home/APSearch',
        component: APSearch,
        meta: {
          title: i18n.t('comm.APSearch')
        }
      },
      {
        name:"StockRemainQuery",
        path: '/Home/StockRemainQuery',
        component: StockRemainQuery,
        meta: {
          title: i18n.t('comm.stockRemainQuery')
        }
      }, 
    ]
  },
  {
    path: '/DialogChangePwd', //修改密码弹窗组件
    name:'DialogChangePwd',
    // component:() => import('@/components/DialogChangePwd') //DialogChangePwd
    component:(resolve) => require(['@/components/DialogChangePwd'],resolve) //DialogChangePwd
  }
];
/**
 * 用于二开重写页面routes的方法
 * @param {*} routes 路由对象
 * @param {*} componentArray 组件数组
 * @returns 修改后的路由对象
 */
function OverrideHomeRoutes(routes,componentArray){
  if(componentArray&&componentArray.length>0){
    routes[2].children.forEach(route => {
      componentArray.forEach(ca =>{
        if(route.name == ca.name){
          route.component = ca.component;
          return;
        }
      })
    });
  }
  return routes;
}
/**
 * 完整配置路由的方法 开放出来给二开router调用
 * @param {*} routes 路由
 * @param {*} componentArray 组件数组
 * @returns 用于启动的路由
 */
function startrouter(routes,componentArray){
  var overrideroutes = OverrideHomeRoutes(routes,componentArray)
  //vue-router 实例上的 push 方法返回的是 promise 对象，所以传入的参数期望有一个成功和失败的回调，如果省略不写则会报错。
  const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
  }
  const router = new Router({
    routes: overrideroutes
  })
  router.afterEach((to, from) => {
    if (to.meta.title) {
      document.title = to.meta.title
    } else {
      document.title = "经销商平台"
    }
  })
  return router;
}
var router = startrouter(routes);




export { startrouter,router,routes}